import React from "react";
import styles from "./last-actual-value-and-timestamp-if-string-or-numeric.module.scss";
import { SmallSpinner } from "@src/components/atoms/small-spinner/small-spinner";
import { useI18N } from "@src/language/language-context";
import { TimezoneDate } from "@src/components/atoms/timezone-date/timezone-date";

const cssClassName = "last-actual-value-and-timestamp-if-string-or-numeric";

interface DataTypeLastKnownValueAndTimestampTypes {
  timestamp: string;
  value: string;
}

interface LastActualValueAndTimestampIfStringOrNumericPropTypes {
  timeseriesDataType: string;
  lastKnownValueAndTimestamp?: DataTypeLastKnownValueAndTimestampTypes | null;
}

export const LastActualValueAndTimestampIfStringOrNumeric = ({
  timeseriesDataType,
  lastKnownValueAndTimestamp,
}: LastActualValueAndTimestampIfStringOrNumericPropTypes) => {
  const i18n = useI18N();
  const texts = {
    loading: i18n("modules.ourNodeDetailsPanel.loading"),
    lastKnownTimestampUnavailable: i18n(
      "modules.ourNodeDetailsPanel.lastKnownTimestampUnavailable",
    ),
    noLastKnownValueAvailable: i18n(
      "modules.ourNodeDetailsPanel.noLastKnownValueAvailable",
    ),
    lastKnownValue: i18n("modules.ourNodeDetailsPanel.lastKnownValue"),
  };

  if (
    lastKnownValueAndTimestamp === undefined ||
    timeseriesDataType === undefined
  ) {
    return (
      <div className={styles[cssClassName]}>
        <div className={styles[`${cssClassName}__loading-wrapper`]}>
          <div className={styles[`${cssClassName}__spinner-wrapper`]}>
            <SmallSpinner />
          </div>
          <div className={styles[`${cssClassName}__value`]}>
            {texts.loading}
          </div>
        </div>
      </div>
    );
  }

  if (lastKnownValueAndTimestamp === null || timeseriesDataType === "json") {
    return (
      <div className={styles[cssClassName]}>
        <div className={styles[`${cssClassName}__timestamp`]}>
          {texts.lastKnownTimestampUnavailable}
        </div>
        <div className={styles[`${cssClassName}__value`]}>
          {texts.noLastKnownValueAvailable}
        </div>
      </div>
    );
  }

  const { timestamp, value } = lastKnownValueAndTimestamp;

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__timestamp`]}>
        {texts.lastKnownValue} (
        <TimezoneDate date={timestamp} showRelative />)
      </div>
      <div className={styles[`${cssClassName}__value`]}>{value}</div>
    </div>
  );
};
